module.exports = __webpack_public_path__ + "img/user.fe31786f.png";